import axios from "axios"
import { fetchAccessToken } from "../utils/token"
import toast from "react-hot-toast"
import { BRIDGE_URL } from "../utils/constants"


// Fetch available appointment time slots in DB
export const putAppointmentDatetimes = async (locationId, serviceId, date, staffId = "any") => {

    try {

        if(!locationId || !serviceId || !date) throw new Error("LocationID or ServiceID or Date not found")

        const token = localStorage.getItem("oss-token")
        if(!token) fetchAccessToken()


        const headers = {
            Authorization: `Bearer ${token}`
        }

        const formBody = {
            locationId: locationId,
            serviceId: serviceId,
            date: date,
            staffId: staffId,
            random: "key"
        }

        const res = await axios.put(`${BRIDGE_URL("services/apexrest/appointment/")}`, formBody, { headers })
        if(res.data.length <= 0) {
            toast.error("No slots available for this date")
            return res.data
        }
        return res.data

    } catch (err) {
        console.log(err)
    }

}
